/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect, useState, useMemo } from "react";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import Select, { GroupBase, OptionsOrGroups, PropsValue } from "react-select";
import { format } from "date-fns";
import ReactInputMask from "react-input-mask";
import {limitShift, offset, shift} from "@floating-ui/react";

import { AccountManagerAPIProps, ProductRequestProps, StatisticsPropsType, StatisticsSearchProps } from "./types";
import StatsReports from "../statsReports";

import { dataSitofCare } from "src/constants/contact";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { AuthContext } from "../../../context/authContext";




const CaseFilter: FC<StatisticsPropsType> = ({
  updateQueryParams,
  defaultQueryParams,
  regional_managers,
  rsd,
  isRegionalManager
}): JSX.Element => {
  const [userListing, updateUserListing] = useState<AccountManagerAPIProps>([]);
  const [isClearing, setIsClearing] = useState(false);

  const { userData } = useContext(AuthContext);

  const { control, handleSubmit, watch, getValues, setValue, resetField, reset } = useForm<StatisticsSearchProps>({
    mode: "onChange",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    defaultValues: useMemo(() => defaultQueryParams, []) // 👈 only once
  });

  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const regional_manager = watch("regional_manager_id");



  /**
  * @GetProductListing API to call GetProductListing
  */
  const { data: productData } = useFetch<ProductRequestProps[]>(APIEndpoints.GET_PRODUCTS);


  useEffect(() => {
    resetField("user_id");
    getUserListing(
      {},
      {},
      {
        ...defaultQueryParams,
        regional_manager_id: regional_manager ? (typeof regional_manager === "string" ? regional_manager : (regional_manager as unknown as { value: string; name: string; }).value) : "",
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regional_manager]);



  const { data: userListingData, mutate: getUserListing } =
    useFetch<AccountManagerAPIProps>(APIEndpoints.GET_USER_FOR_ACCOUNT_MANAGER, {}, {}, false);

  useEffect(() => {
    if (userListingData) {
      if (userData && userData.ref_type === "rep") {
        const data = userListingData.find((user) => user.id === userData?.id);
        if (!data)
          updateUserListing([...userListingData, { id: userData?.id || 0, fullname: userData?.name || "" }])
        else
          updateUserListing(userListingData)

        setValue("user_id", userData ? userData.id.toString() : "")
      } else {
        updateUserListing(userListingData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userListingData]);





  const searchForStats = (values: StatisticsSearchProps) => {
    //console.log({ values })
    const updatedValues = {
      ...values,
      start_date: format(values.start_date, "yyyy-MM-dd"),
      end_date: format(values.end_date, "yyyy-MM-dd"),
      period: values.period
        ? typeof values.period === "string"
          ? values.period
          : (values.period as unknown as { value: string; label: string }).value
        : "",
      soc_value:
        values.soc_value ?
          (typeof values.soc_value === "string" ? values.soc_value : (values.soc_value as unknown as { value: string; name: string; }).value)
          : "",
      drug_id:
        values.drug_id ?
          (typeof values.drug_id === "string" ? values.drug_id : (values.drug_id as unknown as { value: string; name: string; }).value)
          : "",
      // filter: values.filter
      //   ? typeof values.filter === "string"
      //     ? values.filter
      //     : (values.filter as unknown as { value: string; label: string }).value
      //   : "",
      user_id:
        values.user_id ?
          (typeof values.user_id === "string" ? values.user_id : (values.user_id as unknown as { value: string; name: string; }).value)
          : "",
      regional_manager_id:
        values.regional_manager_id ?
          (typeof values.regional_manager_id === "string" ? values.regional_manager_id : (values.regional_manager_id as unknown as { value: string; name: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
  };



  const clearFormData = () => {
    //console.log("defaultQueryParams......", defaultQueryParams)
      setIsClearing(true);

    const values: any = {
      ...defaultQueryParams,
      period: '',
      soc_value: '',
      regional_manager_id: userData?.ref_type === "regional_manager" ? regional_manager :  userData?.ref_type === "Manufacturer" && isRegionalManager ? regional_manager : '',
      user_id: "",
      drug_id: "",
      type:"index"
    };
    // updateRegionDropdown([])

    reset(values);
    // updatedFilteredDocListing([]);
    // updatedFilteredPracticeListing([]);
    updateQueryParams(values, true);
      setTimeout(() => setIsClearing(false), 0);

  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const populateCurrentUserInDropdown = (value: string) => {
    if (userListing && userListing.length > 0) {
      const data = userListing.find((option) =>
        option.id.toString() === value
      );

      if (data) return { value: data.id.toString(), label: data.fullname } as unknown as PropsValue<string>;
    }
  };

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="card mt-4">
        <div className="card-header">
          <h4 className="m-0">Statistics</h4>
        </div>
        <div className="card-body px-3 pt-3">
          <div className="row g-2">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="row g-2">
                <div className="col-lg-6">
                  <div className="row g-2">
                    <div className={`col-12 col-sm-12 col-md-${userData && userData.ref_type === "Manufacturer" ? 2 : 4}`}>
                      <Controller
                        name="start_date"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <DatePicker
                            selected={field.value ? new Date(field.value) : new Date()}
                            onChange={(date) => date ? field.onChange(date) : ""}
                            customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                            className="form-control rounded-1" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            maxDate={end_date ? new Date(end_date) : undefined}
                            portalId="root"
                            popperModifiers={[offset(8), shift({ limiter: limitShift({ offset: 20 }) })]}
                          />
                        )}
                      />
                    </div>
                    <div className={`col-12 col-sm-12 col-md-${userData && userData.ref_type === "Manufacturer" ? 2 : 4}`}>
                      <Controller
                        name="end_date"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <DatePicker
                            selected={field.value ? new Date(field.value) : new Date()}
                            onChange={(date) => date ? field.onChange(date) : ""}
                            customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                            className="form-control rounded-1" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            minDate={start_date ? new Date(start_date) : undefined}
                            portalId="root"
                            popperModifiers={[offset(8), shift({ limiter: limitShift({ offset: 20 }) })]}
                          />
                        )}
                      />
                    </div>
                    {((userData && (userData.ref_type === "Manufacturer"))) && 
                      <div className={`col-12 col-sm-12 col-md-${userData && userData.ref_type === "Manufacturer" ? 4 : 4}`}>
                        <Controller
                          name="regional_manager_id"
                          control={control}
                          render={({ field }) => {
                            const options =
                              regional_managers?.map((user) => ({
                                value: user.id.toString(),
                                label: user.name,
                              })) || [];

                            return (
                              <Select
                                options={options}
                                placeholder="Regional Manager..."
                                isDisabled={isRegionalManager}
                                //isClearable={true}
                                // ✅ map string → object for UI
                                value={options.find((o) => o.value === field.value) || null}

                                // ✅ ONLY convert object → string
                                onChange={(option) => {
                                  field.onChange(option ? option.value : "");
                                  // if (!option) {
                                  //   searchForStats(
                                  //       ...defaultQueryParams,
                                  //       regional_manager_id:"",
                                  //       user_id: "",
                                  //   );
                                  // }
                                }}
                              />
                            );
                          }}
                        />

                      </div>}
                    {userData && userData.ref_type !== "rep" ? (
                      <div className="col-12 col-sm-12 col-md-4">
                        <Controller
                          name="user_id"
                          control={control}
                          render={({ field }) => {
                            const options =
                              userListingData?.map((user) => ({
                                value: user.id.toString(),
                                label: user.fullname,
                              })) || [];

                            return (
                              <Select
                                //isClearable={true}
                                isDisabled={userData?.ref_type === "rep"}
                                options={options}
                                placeholder="Account Director..."

                                value={options.find((o) => o.value === field.value) || null}

                                onChange={(option) => {
                                  field.onChange(option ? option.value : "");
                                }}
                              />
                            );
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6" >
                  <div className="row g-2">

                    <div className={`col-12 col-sm-12 col-md-${userData && userData.ref_type === "rep" ? 6 : 4}`}>
                      <Controller
                        name="soc_value"
                        control={control}
                        render={({ field }) => (
                          <Select
                            isClearable={true}
                            options={(dataSitofCare && dataSitofCare.length > 0 ?
                              dataSitofCare.map((item) => ({
                                value: item.value,
                                label: item.name
                              }))
                              : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="soc_value"
                            {...field}
                            placeholder={'All SOC ...'}
                          />
                        )}
                      />
                    </div>
                    <div className={`col-12 col-sm-12 col-md-${userData && userData.ref_type === "rep" ? 6 : 4}`}>
                      <Controller
                        name="drug_id"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <Select
                            isClearable={true}
                            options={
                              (productData && productData.length > 0
                                ? productData.map((item) => ({
                                  value: item.id,
                                  label: item.name,
                                }))
                                : []) as unknown as OptionsOrGroups<
                                  string,
                                  GroupBase<string>
                                >
                            }
                            id="drug_id"
                            {...field}
                            placeholder={"All Product ..."}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-2 col-lg-2 mb-3">
                      <button type="submit" className="btn btn-primary w-100">Refresh</button>
                    </div>
                    <div className=" col-12 col-sm-12 col-md-2 col-lg-2 mb-3 ">
                      <button className="btn btn-outline-secondary w-100" type="button" disabled={isClearing} onClick={clearFormData}>
                        Clear
                      </button></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <StatsReports getValues={getValues} />
        </div>

      </div>

    </form >
  );
};

export default CaseFilter;
